<template>
  <template v-if="events.length"
    ><Item v-for="item in events" :key="item.id" :item="item"
  /></template>
  <div v-else :class="$style.empty">Нет событий :(</div>
</template>

<script>
import Item from "./Item.vue";
export default {
  components: {
    Item,
  },
  computed: {
    events() {
      return this.$store.state.events.events;
    },
  },
};
</script>

<style lang="scss" module>
.empty {
  text-align: center;
  padding: 2rem 0 0.5rem 0;
  color: $t-secondary;
}
</style>
